import { takeEvery, put, call } from "redux-saga/effects";

// Login Redux States
import { CHANGE_PASSWORD, GET_PASSWORD_HISTORY } from "./actionTypes";
import {
  userChangePasswordSuccess,
  userChangePasswordError,
  getPasswordHistorySuccess,
  getPasswordHistoryError,
} from "./actions";

//Include Both Helper File with needed methods
import {
  postChangePwd,
  getChangePwdHistory,
} from "../../../helpers/django_api_helper";

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* changeUser({ payload: { user } }) {
  try {
    const response = yield call(postChangePwd, user);
    if (response) {
      yield put(
        userChangePasswordSuccess(
          "Congratulations! Your password is changed, you can now login to your account using new password."
        )
      );
      // NEW: refresh history right after a successful change
      yield put({
        type: GET_PASSWORD_HISTORY,
        payload: { user_id: user.user_id },
      });
    }
  } catch (error) {
    // console.error("Change Password Error:", error);
    if (error.response.status == 400) {
      yield put(userChangePasswordError(error.response.data));
    } else {
      yield put(userChangePasswordError(error.response.data));
    }
  }
}

// NEW: fetch password change history
function* fetchPasswordHistory({ payload: { user_id } }) {
  try {
    const response = yield call(getChangePwdHistory, user_id);
    yield put(getPasswordHistorySuccess(response.data)); // FIXED
  } catch (error) {
    yield put(
      getPasswordHistoryError(
        error.response ? error.response.data : "Failed to load history"
      )
    );
  }
}
function* changePasswordSaga() {
  yield takeEvery(CHANGE_PASSWORD, changeUser);
  yield takeEvery(GET_PASSWORD_HISTORY, fetchPasswordHistory); // NEW
}

export default changePasswordSaga;
